import { render, staticRenderFns } from "./section-gallery.vue?vue&type=template&id=515933f4&scoped=true"
import script from "./section-gallery.vue?vue&type=script&lang=js"
export * from "./section-gallery.vue?vue&type=script&lang=js"
import style0 from "./section-gallery.vue?vue&type=style&index=0&id=515933f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515933f4",
  null
  
)

export default component.exports